import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function WhyChooseUs() {
  return <ComingSoon title="Why Choose Us" />;
}
